export const PATHS = {
    ROUTES_PAGE: '/information/schedule',
    ROUTE_SCHEDULE_PAGE: '/information/schedule/:cityFrom/:cityTo',
};
